/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
*/
import React from 'react';
import { RotateCcwIcon } from './icons';
import ImageProcessingOverlay from './ImageProcessingOverlay';

interface CanvasProps {
  displayImageUrl: string | null;
  onStartOver: () => void;
  isLoading: boolean;
  loadingMessage: string;
  loadingMessages?: string[];
}

const Canvas: React.FC<CanvasProps> = ({ 
  displayImageUrl, 
  onStartOver, 
  isLoading, 
  loadingMessage,
  loadingMessages
}) => {
  return (
    <div className="w-full h-full flex items-center justify-center p-4 relative animate-zoom-in">
      {/* Start Over Button - Floating, Mobile Optimized */}
      <button
          onClick={onStartOver}
          className="absolute top-4 right-4 z-30 flex items-center justify-center gap-2 bg-white/95 backdrop-blur-sm border border-slate-200 text-slate-700 font-medium py-2.5 px-4 rounded-lg transition-all duration-200 ease-in-out hover:bg-white hover:shadow-md active:scale-95 text-sm min-h-[44px] min-w-[44px]"
      >
          <RotateCcwIcon className="w-4 h-4" />
          <span className="hidden sm:inline">Chọn ảnh khác</span>
      </button>

      {/* Image Display - Full Screen Mobile */}
      <div className="relative w-full h-full flex items-center justify-center overflow-hidden">
        {displayImageUrl ? (
          <div className="relative w-full h-full flex items-center justify-center">
            <img
                key={displayImageUrl}
                src={displayImageUrl}
                alt="Phone Case Design"
                className="max-w-full max-h-full object-contain rounded-lg"
            />
            {/* Enhanced Loading Overlay with effects on image */}
            <ImageProcessingOverlay
              isLoading={isLoading}
              message={loadingMessage}
              messages={loadingMessages}
              showShimmer={true}
              showPulse={true}
            />
          </div>
        ) : (
            <div className="w-full max-w-xs aspect-[3/4] bg-slate-100 border-2 border-dashed border-slate-300 rounded-xl flex flex-col items-center justify-center text-slate-400">
              <p className="text-sm">Chưa có hình ảnh</p>
            </div>
        )}
      </div>
    </div>
  );
};

export default Canvas;